

















































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Card, Tag } from 'element-ui';
import BankAccountUpsert from '@/components/modals/BankAccountUpsert.vue';
import Callout from '@/components/Callout.vue';
import Pagination from '@/mixins/pagination';
import { bankAccountService } from '@/services/BankAccountService';

// gql
import fetchAccountListQuery from '@/graphql/queries/bankaccounts/FetchAccountList.gql';

// types
import { BankAccountFields } from '@/types/graphql/schemaTypes';

@Component({
  apollo: {
    bankAccounts: {
      query: fetchAccountListQuery,
      prefetch: true,
      variables() {
        return {
          customerOrganizationId: this.$route.params.id,
          pagination: {
            page: parseInt(this.$route.query.page, 10) || this.currentPage,
            per: parseInt(this.$route.query.size, 10) || this.paginationSize
          }
        };
      },
      update(data) {
        this.totalCount = data.bankAccountsPagination.totalCount;
        return data.bankAccounts;
      },
      error() {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.fetch'),
          time: 3000
        });
      }
    }
  },
  components: {
    BankAccountUpsert,
    Callout,
    Pagination,
    'el-card': Card,
    'el-tag': Tag
  }
})
export default class BankAccounts extends Mixins(Pagination) {
  private bankAccounts: BankAccountFields[] = [];
  private showModal = false;
  private upsertAccount: BankAccountFields | null = null;

  private openEditModal(account: BankAccountFields | null) {
    this.upsertAccount = account;
    this.showModal = true;
  }

  private openNewModal() {
    this.upsertAccount = null;
    this.showModal = true;
  }

  private closeModal() {
    this.showModal = false;
    this.upsertAccount = null;
  }

  private locationUpsertHandler() {
    this.closeModal();
    this.$apollo.queries.bankAccounts.refetch();
  }

  private async deleteAccount(account: BankAccountFields) {
    try {
      const response = await bankAccountService.deleteBankAccount(account.id);

      if (response.data) {
        this.$apollo.queries.bankAccounts.refetch();
        this.$store.dispatch('Alert/addAlert', {
          type: 'success',
          message: this.$t('success.updated'),
          time: 2000
        });
      }
    } catch (e) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    }
  }
}
